module.exports = __webpack_public_path__ + "static/media/img130_R.256f1726.jpg";